export const SET_TOKEN = "SET_TOKEN";

export const setToken = data => {
  return {
    type: SET_TOKEN,
    data
  };
};

const tokenInitialState = null;
export const tokenReducer = (state = tokenInitialState, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return action.data;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./frontend/src/actions/token.js